import { useState } from "react";
import p_nav_previous from "../../../Assets/Images/p_nav_previous.svg";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MembershipCard from "../../../Components/MembershipCard/MembershipCard";
import { BsThreeDots } from "react-icons/bs";
// import "./membershipList.css";
import Lottie from "lottie-react";
import empotyLottie from "../../../Assets/lottieFiles/emptybox.json"
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import NodeaxiosInstance from "../../../Services/nodeaxios";
import { toast } from "react-toastify";
import Kitchen_membership_card from "../../../Components/KitchenMembershipCard/Kitchen_membership_card";
import { useSelector } from "react-redux";
import KitchenMembershipdetailCard from "../../../Components/KitchenMembershipCard/KitchenMembershipdetailCard";
import KitchenMembershiplistCard from "../../../Components/KitchenMembershipCard/KitchenMembershiplistCard";
const Kitchen_MymembershipList = () => {
    const location = useLocation();
    const { vendor_id } = useParams();
    const [pageLoaded, setPageLoaded] = useState(false);
    const navigate = useNavigate();
    const [data, setData] = useState();
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);
    useEffect(() => {
        fetch_ticket_deta()
    }, [])

    const fetch_ticket_deta = async () => {
        try {
            const headers = { Authorization: userData?.token };
            const response = await NodeaxiosInstance.get("kitchen/my-membership-bookings", {
                params: {
                    vendor_id: vendor_id,
                },
                headers,
            });

            if (response.status == 200) {
                setPageLoaded(true);
                setData(response.data?.result);
                //   setErrorMessage(""); // clear any previous error 
            } else {
                throw new Error(`Unexpected response status: ${response.status}`);
            }
        } catch (error) {
            console.error("Error fetching ticket details:", error);
            setPageLoaded(false);
            // setErrorMessage("Failed to load ticket details. Please try again later.");

            toast("Try Again Later", {
                position: "bottom-center", autoClose: 5000, hideProgressBar: true, closeOnClick: true,
                pauseOnHover: true, draggable: true, progress: undefined, theme: "light", className: "text-danger toast-style-1",
            });
        }
    };

    return (
        <>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img src={p_nav_previous} width={"24px"} height={"16px"} alt="Previous Button" role="button" onClick={() => navigate(-1)} />
                    <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">Membership</div>
                </div>
            </div>
            <div className="">
                <div className="messengerList scroller-style-y" style={{ overflowX: 'hidden' }}>
                    <div>
                        {
                            pageLoaded ?
                                data.length > 0 ? (
                                    data.map((membership, index) => (
                                        <div className="p-1 ms-3 mt-2" key={index}>
                                            {/* <Kitchen_membership_card Data={membership} pageName={'listScreen'} /> */}
                                            <KitchenMembershiplistCard item={membership} />
                                        </div>
                                    ))
                                )

                                    : (
                                        <>
                                            <div>
                                                <Lottie animationData={empotyLottie} />
                                            </div>
                                            <p className='text-dark text-center mt-5 ff-balooPaaji2-bold fs-20 '>No Membership Available</p>
                                        </>
                                    ) :
                                <div className='d-flex justify-content-center skeleton-bg'>
                                    <div >
                                        <Skeleton height={190} width={375} borderRadius={10} />
                                        <Skeleton height={190} width={375} borderRadius={10} />
                                        <Skeleton height={190} width={375} borderRadius={10} />
                                        <Skeleton height={190} width={375} borderRadius={10} />
                                    </div>
                                </div>

                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default Kitchen_MymembershipList;
